/* eslint-disable no-prototype-builtins */
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styles from './FilterModal.module.scss';
import { ErrorField, InputText, StyledSelect } from '../../lib/HooksFormFields';
import { getAssociatedLabelsAction } from '../../actions/indicators';

export default function FilterModal({
  indicator, filter, options, handleChangeFilters, closeModale,
}) {
  const {
    control,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: {
      errors,
    },
  } = useForm();
  const { t } = useTranslation();
  const [listsOptions, setListsOptions] = useState([]);
  const [isHierarchical, setIsHierarchical] = useState(false);
  const hierarchyMapRef = useRef({});
  const previousListRef = useRef([]);
  const [keys0ptions, setKeyOptions] = useState();
  const filters = indicator('config.filters');
  const watchIndicator = indicator();
  const property = watch('property');

  const isList = property?.type === 'OrderedMultipleChoiceList' || property?.type === 'MultipleEntityLink' || property?.type === 'MultipleChoiceList';
  const isNumber = property?.type === 'Numeric' || property?.type === 'Float';
  const booleansOptions = [{ value: 'true', label: t('options.yes') }, { value: 'false', label: t('options.no') }];

  function onSubmit(values) {
    const updatedFilters = [...filters];
    const index = filters.findIndex((f) => f.id === values.id);
    if (index === -1) {
      handleChangeFilters([...updatedFilters, { ...values, id: new Date().toString() }]);
    } else {
      updatedFilters[index] = { ...values };
      handleChangeFilters(updatedFilters);
    }
    closeModale();
  }

  async function generateOptions() {
    const list = [];
    const labels = [];
    const associatedConfig = {
      lang: localStorage.getItem('lang') || 'fr',
      associatedId: property.associatedId || property.associatedDomainId,
      api: watchIndicator.requests,
      key: watchIndicator.key,
    };
    if (associatedConfig?.associatedId) {
      const res = await getAssociatedLabelsAction(associatedConfig);
      res.data.forEach((v) => {
        labels.push({
          element_id: v.element_id,
          label: v.label,
          parent: v.parent || null,
        });
      });
    }

    const numbers = [];
    if (isNumber) {
      options.data.filter((d) => (d[property.value] || d[property.parent] ? d : null)).forEach(
        (d) => {
          if (!property.parent && d[property.value]) {
            const value = parseFloat(d[property.value]);
            numbers.push(value);
          }
          if (property.parent && d[property.parent][property.value]) {
            const value = parseFloat(d[property.parent][property.value]);
            numbers.push(value);
          }
          if (property.parent && Array.isArray(d[property.parent])) {
            d[property.parent].forEach((p) => {
              if (p[property.value]) {
                const value = parseFloat(p[property.value]);
                numbers.push(value);
              }
            });
          }
        },
      );
    }
    if (numbers.length > 0) {
      const resetData = watch();
      resetData.min = property.value === filter?.property?.value
      && filter?.min ? filter?.min : Math.min(...numbers);
      resetData.max = property.value === filter?.property?.value
      && filter?.max ? filter?.max : Math.max(...numbers);
      reset(resetData);
    }
    if (isList) {
      const label = property?.value;
      options?.data?.forEach((d) => {
        if (d[label]) {
          d[label].forEach((a) => {
            const key = a?.libelle || a?.label || a?.name || a?.title || a?.core_hasListName;
            // Resolve parentId: from parent_id field OR from parent object (Craft API returns parent: {element_id, label})
            const resolvedParentId = a?.parent_id || a?.parent?.element_id || null;
            if (!list.find((o) => o.value === key)) {
              list.push({ value: key, label: key, elementId: a?.element_id, parentId: resolvedParentId });
            }
          });
        }
        if (property.parent && Array.isArray(d[property.parent])) {
          d[property.parent].forEach((p) => {
            if (p[label]) {
              if (Array.isArray(p[label])) {
                p[label].forEach((a) => {
                  const key = a?.element_id;
                  const keyLabel = labels.find((l) => l.element_id === key)
                    || options.data.find((l) => l.entity_id === key);
                  const resolvedParentId = a?.parent_id || a?.parent?.element_id || null;
                  if (key && !list.find((o) => o.value === key)) {
                    list.push({ value: key, label: keyLabel.label, elementId: a?.element_id, parentId: resolvedParentId });
                  }
                });
              } else {
                const key = p[label]?.element_id;
                const keyLabel = labels.find((l) => l.element_id === key);
                const resolvedParentId = p[label]?.parent_id || p[label]?.parent?.element_id || null;
                if (key && !list.find((o) => o.value === key)) {
                  list.push({ value: key, label: keyLabel?.label, elementId: p[label]?.element_id, parentId: resolvedParentId });
                }
              }
            }
          });
        }
      });
    }
    if (property?.type === 'UniqueChoiceList') {
      const label = property?.value;
      options?.data?.forEach((d) => {
        if (d[label]) {
          const a = d[label];
          const key = a?.libelle || a?.label || a?.name || a?.title || a?.core_hasListName;
          const resolvedParentId = a?.parent_id || a?.parent?.element_id || null;
          if (!list.find((o) => o.value === key)) {
            list.push({ value: key, label: key, elementId: a?.element_id, parentId: resolvedParentId });
          }
        }
        if (property.parent && Array.isArray(d[property.parent])) {
          d[property.parent].forEach((p) => {
            const key = p[label]?.element_id;
            const keyLabel = labels.find((l) => l.element_id === key);
            const resolvedParentId = p[label]?.parent_id || p[label]?.parent?.element_id || null;
            if (key && !list.find((o) => o.value === key)) {
              list.push({ value: key, label: keyLabel?.label, elementId: p[label]?.element_id, parentId: resolvedParentId });
            }
          });
        }
      });
    }

    // Enrich list items with parent info from associated-labels data
    if (labels.length > 0) {
      list.forEach((item) => {
        if (!item.parentId && item.elementId) {
          const labelInfo = labels.find((l) => l.element_id === item.elementId);
          if (labelInfo?.parent?.element_id) {
            item.parentId = labelInfo.parent.element_id;
          }
        }
        // Also resolve parentId from value (when value === element_id)
        if (!item.parentId && item.value) {
          const labelInfo = labels.find((l) => l.element_id === item.value);
          if (labelInfo?.parent?.element_id) {
            item.parentId = labelInfo.parent.element_id;
            if (!item.elementId) {
              item.elementId = item.value;
            }
          }
        }
        // Fallback: resolve parentId by matching label name (when value is a display name)
        if (!item.parentId && !item.elementId && item.value) {
          const labelInfo = labels.find((l) => l.label === item.value);
          if (labelInfo) {
            item.elementId = labelInfo.element_id;
            if (labelInfo.parent?.element_id) {
              item.parentId = labelInfo.parent.element_id;
            }
          }
        }
      });
      // Add parent items from labels that aren't already in the list
      labels.forEach((labelItem) => {
        if (labelItem.parent?.element_id) {
          const parentId = labelItem.parent.element_id;
          const parentInList = list.find(
            (o) => o.elementId === parentId || o.value === parentId,
          );
          if (!parentInList) {
            const parentLabel = labels.find((l) => l.element_id === parentId);
            if (parentLabel) {
              list.push({
                value: parentLabel.label,
                label: parentLabel.label,
                elementId: parentId,
                parentId: parentLabel.parent?.element_id || null,
              });
            }
          }
        }
      });
    }

    // Detect hierarchical lists and build tree structure
    if (process.env.NODE_ENV === 'development') {
      console.log('[FilterModal] list items:', list.map((item) => ({ value: item.value, elementId: item.elementId, parentId: item.parentId })));
    }
    const hasHierarchy = list.some((item) => item.parentId);
    if (hasHierarchy) {
      // Build a map: elementId -> option for quick lookup
      const elementMap = {};
      list.forEach((item) => {
        if (item.elementId) {
          elementMap[item.elementId] = item;
        }
      });

      // Build parent -> children map for cascade deselection
      const childrenMap = {};
      list.forEach((item) => {
        if (item.parentId && elementMap[item.parentId]) {
          if (!childrenMap[item.parentId]) {
            childrenMap[item.parentId] = [];
          }
          childrenMap[item.parentId].push(item);
        }
      });
      hierarchyMapRef.current = { elementMap, childrenMap };

      // Compute depth for each item
      function getDepth(item) {
        let depth = 0;
        let current = item;
        while (current?.parentId && elementMap[current.parentId]) {
          depth += 1;
          current = elementMap[current.parentId];
        }
        return depth;
      }

      // Sort items in tree order (parent before children, recursively)
      function buildTreeOrder(items) {
        const roots = items.filter((item) => !item.parentId || !elementMap[item.parentId]);
        const result = [];
        function addWithChildren(node) {
          result.push({ ...node, depth: getDepth(node) });
          const children = childrenMap[node.elementId] || [];
          children
            .sort((a, b) => (a.label || '').localeCompare(b.label || ''))
            .forEach((child) => addWithChildren(child));
        }
        roots
          .sort((a, b) => (a.label || '').localeCompare(b.label || ''))
          .forEach((root) => addWithChildren(root));
        // Add items that couldn't be placed in the tree (orphans)
        items.forEach((item) => {
          if (!result.find((r) => r.value === item.value)) {
            result.push({ ...item, depth: 0 });
          }
        });
        return result;
      }

      const orderedList = buildTreeOrder(list);
      setListsOptions(orderedList);
      setIsHierarchical(true);
    } else {
      setListsOptions(list);
      setIsHierarchical(false);
      hierarchyMapRef.current = {};
    }
  }

  useEffect(() => {
    if (options?.keys) {
      const grouped = [];
      // CREATE FILTERS OPTIONS
      options.keys.forEach((k) => {
        const isFilter = k.type === 'MultipleChoiceList'
        || k.type === 'UniqueChoiceList'
        || k.type === 'OrderedMultipleChoiceList'
        || k.type === 'Numeric'
        || k.type === 'Float'
        || k.type === 'Boolean'
        || k.type === 'Date';
        if (!k.group && isFilter) {
          grouped.push(k);
        }
      });
      options.keys.forEach((k) => {
        if (k.group && !grouped.find((g) => g.label === k.group)) {
          const optionsList = [];
          options.keys.filter((opt) => opt.group === k.group)
            .sort((a, b) => a.label.localeCompare(b.label))
            .forEach((opt) => {
              const isFilter = opt.type === 'MultipleChoiceList'
              || opt.type === 'UniqueChoiceList'
              || opt.type === 'OrderedMultipleChoiceList'
              || opt.type === 'Numeric'
              || opt.type === 'Float'
              || opt.type === 'Boolean'
              || opt.type === 'Date';
              if (!optionsList.find((o) => o.value === opt.value) && isFilter && !opt.value.includes('aggregation.')) {
                optionsList.push(opt);
              }
            });
          const group = {
            label: k.group,
            options: optionsList,
          };
          grouped.push({ ...group });
        }
      });
      setKeyOptions(grouped);
    }
  }, [options?.keys]);

  useEffect(() => {
    if (options?.data?.length > 0 && property?.value) {
      generateOptions();
    }
  }, [options?.data, property?.value]);

  useEffect(() => {
    if (filter) {
      reset(filter);
      if (filter.list && Array.isArray(filter.list)) {
        previousListRef.current = filter.list;
      }
    }
  }, [filter]);

  return (
    <div className={styles.container}>
      <h2>{filter ? t('indicator.filters.update') : t('indicator.filters.new')}</h2>
      <div className={styles.row}>
        <div className={styles.col}>
          <InputText
            name="name"
            control={control}
            label={t('indicator.filters.name')}
          />
        </div>
      </div>
      {keys0ptions
        && <div className={styles.row}>
          <div className={styles.col}>
            <StyledSelect
              name="property"
              control={control}
              label={t('indicator.filters.property')}
              placeholder={t('indicator.filters.property')}
              isSearchable
              options={keys0ptions}
              rules={{
                required: t('input.required'),
              }}
            />
            {errors?.property?.message && <ErrorField message={errors.property.message} />}
            {property?.value && options.data.filter((d) => (d[property.value] || (d[property.parent] && d[property.parent]?.find((v) => v[property.value])) ? d : null)).length === 0 && <ErrorField message={t('indicator.noData', { name: property?.value })} />}
          </div>
        </div>
      }
      {listsOptions.length > 0 && (isList || property?.type === 'UniqueChoiceList')
        && <div className={styles.row}>
          <div className={styles.col}>
            <StyledSelect
              name="list"
              control={control}
              label={t('indicator.filters.fields')}
              placeholder={t('indicator.filters.fields')}
              isSearchable
              isClearable
              isMulti
              options={[{ label: t('selectAll'), value: '*' }, ...listsOptions]}
              {...(isHierarchical ? {
                formatOptionLabel: (option) => {
                  if (option.value === '*') return option.label;
                  return (
                    <div className={styles.hierarchicalOption} style={{ paddingLeft: (option.depth || 0) * 20 }}>
                      {option.depth > 0 && <span className={styles.hierarchicalIndent}>└</span>}
                      <span>{option.label}</span>
                    </div>
                  );
                },
                handleChange: (newValues) => {
                  if (!newValues || !Array.isArray(newValues)) {
                    previousListRef.current = [];
                    return;
                  }
                  const currentValues = previousListRef.current || [];
                  const { elementMap, childrenMap } = hierarchyMapRef.current;
                  previousListRef.current = newValues;
                  if (!elementMap || !childrenMap) return;

                  // Detect which items were removed
                  const removedItems = currentValues.filter(
                    (prev) => !newValues.find((next) => next.value === prev.value),
                  );

                  // For each removed parent, collect all descendant values to also remove
                  const valuesToRemove = new Set();
                  function collectDescendants(elementId) {
                    const children = childrenMap[elementId] || [];
                    children.forEach((child) => {
                      valuesToRemove.add(child.value);
                      if (child.elementId) {
                        collectDescendants(child.elementId);
                      }
                    });
                  }
                  removedItems.forEach((item) => {
                    if (item.elementId && childrenMap[item.elementId]) {
                      collectDescendants(item.elementId);
                    }
                  });

                  // If descendants need to be removed, update the form value
                  if (valuesToRemove.size > 0) {
                    const cascadedValues = newValues.filter(
                      (v) => !valuesToRemove.has(v.value),
                    );
                    previousListRef.current = cascadedValues;
                    setValue('list', cascadedValues);
                  }
                },
              } : {})}
            />
          </div>
        </div>
      }
      {(property?.type === 'Boolean')
        && <div className={styles.row}>
          <div className={styles.col}>
            <StyledSelect
              name="booleans"
              control={control}
              label="Séléctionner une propriété"
              placeholder="Séléctionner une propriété"
              isSearchable
              isMulti
              options={booleansOptions}
            />
          </div>
        </div>
      }
      {(property?.type === 'Numeric' || property?.type === 'Float')
        && <>
          <div className={styles.row}>
            <InputText
              name="min"
              type='number'
              control={control}
              label={t('indicator.filters.min')}
            />
          </div>
          <div className={styles.row}>
            <InputText
              name="max"
              type='number'
              control={control}
              label={t('indicator.filters.max')}
            />
          </div>
        </>
      }
      {(property?.type === 'Date')
        && <>
          <div className={styles.row}>
            <InputText
              name="minDate"
              type='date'
              control={control}
              label={t('indicator.filters.minDate')}
            />
          </div>
          <div className={styles.row}>
            <InputText
              name="maxDate"
              type='date'
              control={control}
              label={t('indicator.filters.maxDate')}
            />
          </div>
        </>
      }
      <button
        onClick={handleSubmit(onSubmit)}
      >
        {t('btn.valid')}
      </button>
    </div>
  );
}
